import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Radio, RadioGroup, Stack, Text } from '@chakra-ui/react';

import TooltipHelp from '../../../../common/components/TooltipHelp';
import { useTranslations } from '../../../../contexts/LocalizationContext';
import { QuickContactType } from '../../model/enums/quick-contact-type.enum';

export const QuickContactUserTypeRadioSelect = () => {
  const translations = useTranslations();
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name="type"
      render={({ field: { value, onChange } }) => (
        <RadioGroup onChange={onChange} value={value}>
          <Text mb={2} fontWeight={'400'} fontSize={14} color={'grey.500'}>
            {translations('quick_contacts_add_new_contact_type')}
          </Text>
          <Stack direction="row" justify="space-between" width="100%">
            <Radio size="lg" value={QuickContactType.USER}>
              {translations('quick_contacts_user_type')}
              <TooltipHelp
                label={translations('quick_contacts_user_type_tooltip')}
                bgColor={'grey.600'}
                color={'white'}
              />
            </Radio>
            <Radio size="lg" value={QuickContactType.RESTAURANT}>
              {translations('quick_contacts_restaurant_type')}
              <TooltipHelp
                label={translations('quick_contacts_restaurant_type_tooltip')}
                bgColor={'grey.600'}
                color={'white'}
              />
            </Radio>
          </Stack>
        </RadioGroup>
      )}
    />
  );
};
